import {STEPS} from '../settings.js'
import {handleError} from '../utils.js'

export const getInitialProps = async ({routeInfo, context: {domain, i18n}}) => {
  const {
    location: {state}
  } = routeInfo

  const config = domain.get('config')
  const {
    VEHICLE_SUGGESTER_PATH_PATTERN: homeSuggesterPath,
    VEHICLE_SUGGESTER_BODY_TYPE_PAGE_NAME: pageName,
    VEHICLE_SUGGESTER_FUEL_TYPE_PATH_PATTERN: nextPagePath,
    VEHICLE_SUGGESTER_PATH: previousPagePath
  } = config.get('page')

  const [error, bodyTypesOptionsResponse] = await domain
    .get('get_configurator_body_types_options_vehicles_use_case')
    .execute({
      priceFrom: state?.priceRange?.from,
      priceTo: state?.priceRange?.to
    })
  if (error) {
    return handleError({
      domain,
      i18n,
      error,
      message: 'Error fetching body types options',
      redirectTo: homeSuggesterPath
    })
  }

  const bodyTypeOptions = bodyTypesOptionsResponse.getFilterOptions()

  return {
    description: i18n.t('VEHICLE_SUGGESTER.STEP_BODY_TYPES.DESCRIPTION'),
    h1: i18n.t('COMMON.SUGGESTER'),
    nextPagePath,
    bodyTypeOptions,
    pageName,
    previousPagePath,
    step: STEPS.BODY_TYPES,
    stepBreadcrumb: i18n.t('COMMON.BODY_TYPES'),
    title: i18n.t('VEHICLE_SUGGESTER.STEP_BODY_TYPES.TITLE')
  }
}
